import { RailResponseDTO, TransportTypeDTO } from "../api/response.types";
import { RailStatusesModel } from "entities/shared/railCard.types";
import { DateTimeModel } from "entities/shared/shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";

export enum CardDates {
  atd = "atd",
  etd = "etd",
  ata = "ata",
  eta = "eta",
}

export type DateModel = Record<keyof typeof CardDates, Nullable<DateTimeModel>>;

export type LocationModel = {
  name: Nullable<string>;
  division: Nullable<string>;
  state: Nullable<string>;
  country: Nullable<string>;
  countryCode: Nullable<string>;
  locode: Nullable<string>;
  stationCode: Nullable<string>;
  railwayZone: Nullable<string>;
  formattedName: string;
  lat: Nullable<number>;
  lng: Nullable<number>;
};

export type EquipmentModel = {
  number: Nullable<string>;
  wagonNumber: Nullable<string>;
  trainNumber: Nullable<string>;
  status: ValueOf<typeof RailStatusesModel>;
  from: Nullable<LocationModel>;
  to: Nullable<LocationModel>;
  events: EventModel[];
} & DateModel;

export type TransformedEventModel = { location: Nullable<string>; events: EventModel[] };

export type RouteModel = {
  from: LocationModel;
  to: LocationModel;
} & DateModel;

export const RailTransportTypeModel = {
  ...TransportTypeDTO,
} as const;

export type EventModel = {
  description: Nullable<string>;
  datetime: {
    estimated: Nullable<string>;
    actual: Nullable<string>;
  };
  location: LocationModel | null;
  transport: ValueOf<typeof RailTransportTypeModel>;
};

export type ResponseModel = RailResponseDTO;
